import * as React from "react";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { wrap } from "popmotion";
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import './styles.css'
import { useSelector } from "react-redux";
import { dispatch } from "../..";
import { handleIndexChange } from "../../app/features/itemSlice";

const variants = {
  enter: (direction) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    };
  }
};

/**
 * Experimenting with distilling swipe offset and velocity into a single variable, so the
 * less distance a user has swiped, the more velocity they need to register as a swipe.
 * Should accomodate longer swipes and short flicks without having binary checks on
 * just distance thresholds and velocity > 0.
 */
const swipeConfidenceThreshold = 10000;
const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};

const Carousel = ({ }) => {
  const { previewImg, previewImgIndex } = useSelector(state => state?.item)
  const [[page, direction], setPage] = useState([0, 0]);

  // We only have 3 previewImg, but we paginate them absolutely (ie 1, 2, 3, 4, 5...) and
  // then wrap that within 0-2 to find our image ID in the array below. By passing an
  // absolute page index as the `motion` component's `key` prop, `AnimatePresence` will
  // detect it as an entirely new image. So you can infinitely paginate as few as 1 previewImg.
  const imageIndex = wrap(0, previewImg.length, page);

  const paginate = (newDirection) => {
    dispatch(handleIndexChange(newDirection))
  };

  React.useEffect(() => {
    //  console.log("imageIndex", imageIndex)
  }, [imageIndex])


  return (
    <>
      <AnimatePresence initial={false} custom={direction}>
        <motion.img
          key={page}
          src={previewImg[previewImgIndex]?.uri}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          className="object-cover z-40 object-center absolute mx-auto"
          exit="exit"
          transition={{
            x: { type: "spring", stiffness: 300, damping: 30 },
            opacity: { duration: 0.2 },
          }}
          drag="x"
          dragConstraints={{ left: 0, right: 0 }}
          dragElastic={1}
          onDragEnd={(e, { offset, velocity }) => {
            const swipe = swipePower(offset.x, velocity.x);

            if (swipe < -swipeConfidenceThreshold) {
              paginate(1);
            } else if (swipe > swipeConfidenceThreshold) {
              paginate(-1);
            }
          }}
        />
      </AnimatePresence>
      <div className="next-carousel" onClick={() => paginate(1)}>
        <ChevronRightIcon className=" h-5 w-5 text-white" aria-hidden="true" />
      </div>
      <div className="prev-carousel" onClick={() => paginate(-1)}>
        <ChevronRightIcon className=" h-5 w-5 text-white" aria-hidden="true" />
      </div>
    </>
  );
};

export default Carousel;
